import { FC, useEffect } from 'react';
import { Helmet } from "react-helmet";

import favicons from '../../../shared/assets/favicons';

import { AppTester } from "../../../supporting";
import { useRouteMatch } from "react-router-dom";
import {useProfile} from "../../../core/hooks/auth/useProfile";
import useMetaImage from 'shared/components/AlteredHelmet/useMetaImage';
import useMetaDescription from 'shared/components/AlteredHelmet/useMetaDescription';
import useCanonical from './useCanonical';


const getIconSet = () => {
  if (AppTester.isLPUDesign()) {
    return favicons.lpu;
  }
  if (AppTester.isPortfolio365()) {
    return favicons.portfolio;
  }
  if (AppTester.isKiiidsArt()) {
    return favicons.kiiids
  }
  if (AppTester.isDaMuseum()) {
    return favicons.dum
  }
  if (AppTester.isMediiia()) {
    return favicons.mediiia
  }
  if (AppTester.isBrnd()) {
    return favicons.brnd
  }
  if (AppTester.isDvaDesign()) {
    return favicons.dvadesign
  }
  if (AppTester.isGeoDafes()) {
    return favicons.dafes
  }
  if (AppTester.isGeograffee()) {
    return favicons.geograffee;
  }
  if (AppTester.isAgeytomesh()) {
    return favicons.at;
  }
  if (AppTester.isOnlines()) {
    return favicons.onlinesdesign;
  }
  if (AppTester.isGalllleryArt()) {
    return favicons.oa;
  }
  if (AppTester.isHSEDesign() || AppTester.isSchool() || AppTester.isOnlineHSEDesign()) {
    return favicons.hse;
  }
  if (AppTester.isSuperPuper()) {
    return favicons.superpuper
  }
  if (AppTester.isCGRAVE()) {
    return favicons.cgrave
  }
  if (AppTester.isBooksGallllery()) {
    return favicons.gallllery
  }
  if (AppTester.isContinuumSite()) {
    return favicons.continuum
  }
  if (AppTester.isGreenAward()) {
    return favicons.greenward
  }
  if (AppTester.isAdcrDafesNet()) {
    return favicons.adcr
  }
  if (AppTester.isMonaLisaTravels()) {
    return favicons.monalisatravels
  }
  return favicons.deziiign;
}

const getManifest = () => {
  const {
    small,
    medium,
    large,
  } = getIconSet();

  const manifest = {
    "short_name": "Deziiign",
    "name": "Deziiign",
    "icons": [
      {
        "src": small,
        "sizes": "64x64 32x32 24x24 16x16",
        "type": "image/x-icon"
      },
      {
        "src": medium,
        "type": "image/png",
        "sizes": "192x192"
      },
      {
        "src": large,
        "type": "image/png",
        "sizes": "512x512"
      }
    ],
    "start_url": ".",
    "display": "standalone",
    "theme_color": "#000000",
    "background_color": "#ffffff"
  }

  const stringManifest = JSON.stringify(manifest, null, 2);
  const blob = new Blob([stringManifest], { type: 'application/json' });
  return URL.createObjectURL(blob);
}

const AlteredHelmet: FC = () => {
  const { small, medium } = getIconSet();
  const manifest = getManifest();
  const isOnlines = AppTester.isOnlines();
  const isSchool = AppTester.isSchool();
  const isHseSpace = AppTester.isHseSpace();
  const isMainPage = !!useRouteMatch('/');
  const profile = useProfile();

  //todo придумать другой способ для ssr
  const domain = window.location.origin;
  const metaImage = useMetaImage();
  const metaDescription = useMetaDescription();
  const canonicalUrl = useCanonical();

  return (
    <Helmet>
      {metaDescription}
      {metaImage}
      {isHseSpace && <meta name="robots" content="noindex" />}
      {/* {canonicalUrl && <link rel="canonical" href={canonicalUrl} />} */}

      <link rel="shortcut icon" href={small}/>
      <link rel="apple-touch-icon" href={medium}/>
      <link rel="manifest" href={manifest}/>
    </Helmet>
  )
}

export default AlteredHelmet;import { FC, useEffect } from 'react';
import { Helmet } from "react-helmet";

import favicons from '../../../shared/assets/favicons';

import { AppTester } from "../../../supporting";
import { useRouteMatch } from "react-router-dom";
import {useProfile} from "../../../core/hooks/auth/useProfile";
import useMetaImage from 'shared/components/AlteredHelmet/useMetaImage';
import useMetaDescription from 'shared/components/AlteredHelmet/useMetaDescription';
import useCanonical from './useCanonical';


const getIconSet = () => {
  if (AppTester.isLPUDesign()) {
    return favicons.lpu;
  }
  if (AppTester.isPortfolio365()) {
    return favicons.portfolio;
  }
  if (AppTester.isKiiidsArt()) {
    return favicons.kiiids
  }
  if (AppTester.isDaMuseum()) {
    return favicons.dum
  }
  if (AppTester.isMediiia()) {
    return favicons.mediiia
  }
  if (AppTester.isBrnd()) {
    return favicons.brnd
  }
  if (AppTester.isDvaDesign()) {
    return favicons.dvadesign
  }
  if (AppTester.isGeoDafes()) {
    return favicons.dafes
  }
  if (AppTester.isGeograffee()) {
    return favicons.geograffee;
  }
  if (AppTester.isAgeytomesh()) {
    return favicons.at;
  }
  if (AppTester.isOnlines()) {
    return favicons.onlinesdesign;
  }
  if (AppTester.isGalllleryArt()) {
    return favicons.oa;
  }
  if (AppTester.isHSEDesign() || AppTester.isSchool() || AppTester.isOnlineHSEDesign()) {
    return favicons.hse;
  }
  if (AppTester.isSuperPuper()) {
    return favicons.superpuper
  }
  if (AppTester.isCGRAVE()) {
    return favicons.cgrave
  }
  if (AppTester.isBooksGallllery()) {
    return favicons.gallllery
  }
  if (AppTester.isContinuumSite()) {
    return favicons.continuum
  }
  if (AppTester.isGreenAward()) {
    return favicons.greenward
  }
  if (AppTester.isAdcrDafesNet()) {
    return favicons.adcr
  }
  if (AppTester.isMonaLisaTravels()) {
    return favicons.monalisatravels
  }
  return favicons.deziiign;
}

const getManifest = () => {
  const {
    small,
    medium,
    large,
  } = getIconSet();

  const manifest = {
    "short_name": "Deziiign",
    "name": "Deziiign",
    "icons": [
      {
        "src": small,
        "sizes": "64x64 32x32 24x24 16x16",
        "type": "image/x-icon"
      },
      {
        "src": medium,
        "type": "image/png",
        "sizes": "192x192"
      },
      {
        "src": large,
        "type": "image/png",
        "sizes": "512x512"
      }
    ],
    "start_url": ".",
    "display": "standalone",
    "theme_color": "#000000",
    "background_color": "#ffffff"
  }

  const stringManifest = JSON.stringify(manifest, null, 2);
  const blob = new Blob([stringManifest], { type: 'application/json' });
  return URL.createObjectURL(blob);
}

const AlteredHelmet: FC = () => {
  const { small, medium } = getIconSet();
  const manifest = getManifest();
  const isOnlines = AppTester.isOnlines();
  const isSchool = AppTester.isSchool();
  const isHseSpace = AppTester.isHseSpace();
  const isMainPage = !!useRouteMatch('/');
  const profile = useProfile();

  //todo придумать другой способ для ssr
  const domain = window.location.origin;
  const metaImage = useMetaImage();
  const metaDescription = useMetaDescription();
  const canonicalUrl = useCanonical();

  return (
    <Helmet>
      {metaDescription}
      {metaImage}
      {isHseSpace && <meta name="robots" content="noindex" />}
      {/* {canonicalUrl && <link rel="canonical" href={canonicalUrl} />} */}

      <link rel="shortcut icon" href={small}/>
      <link rel="apple-touch-icon" href={medium}/>
      <link rel="manifest" href={manifest}/>
    </Helmet>
  )
}

export default AlteredHelmet;